import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { DefaultDataServiceConfig, EntityDataModule, EntityDataService, HttpUrlGenerator } from '@ngrx/data';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { entityConfig } from './entity-metadata';
import { defaultDataServiceConfig } from './services/ajax.service';
import { AlertDataService } from './services/alerts/alerts-data-service';
import { EventDataService } from './services/events/events-data-service';
import { UserDataService } from './services/graph/user-data-service';
import { AppHttpUrlGenerator } from './services/http-url-generator.service';
import { ReportBaselineDataService } from './services/sway/baseline/baselines-data-service';
import { SwayBaselineCurrentPostureCountDataService } from './services/sway/baseline/current_posture_count/baseline-count-data-service';
import { SwayCategoryDataService } from './services/sway/category/category-data-service';
import { SwayDeviationDataService } from './services/sway/deviation/deviation-data-service';
import {
    SwayTicketDataService as SwayTicketCountDataService,
    SwayTicketDataService,
} from './services/sway/ticket/ticket-data-service';
import { NgOctReportModule } from 'projects/oct-report-lib/src/public-api';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        MatProgressSpinnerModule,
        MatIconModule,
        NgOctReportModule,
        HttpClientModule,
        RouterModule.forRoot([]),
        StoreModule.forRoot([]),
        EffectsModule.forRoot([]),
        EntityDataModule.forRoot(entityConfig), // must put after Store and Effects
        !environment.production
            ? StoreDevtoolsModule.instrument({
                  maxAge: 25, // Retains last 25 states
              })
            : [],
    ],
    providers: [
        { provide: DefaultDataServiceConfig, useValue: defaultDataServiceConfig },
        { provide: HttpUrlGenerator, useClass: AppHttpUrlGenerator },
        AlertDataService,
        EventDataService,
        SwayTicketDataService,
        UserDataService,
        ReportBaselineDataService,
        SwayCategoryDataService,
        SwayDeviationDataService,
        SwayBaselineCurrentPostureCountDataService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(
        entityDataService: EntityDataService,
        alertDataService: AlertDataService,
        eventDataService: EventDataService,
        baselineDataService: ReportBaselineDataService,
        userDataService: UserDataService,
        swaySpecDataService: SwayCategoryDataService,
        swayDeviationDataService: SwayDeviationDataService,
        swayBaselineCountDataService: SwayBaselineCurrentPostureCountDataService,
        swayTicketDataService: SwayTicketCountDataService,
    ) {
        entityDataService.registerService('Alert', alertDataService);
        entityDataService.registerService('Baseline', baselineDataService);
        entityDataService.registerService('Event', eventDataService);
        entityDataService.registerService('User', userDataService);
        entityDataService.registerService('Category', swaySpecDataService);
        entityDataService.registerService('Deviation', swayDeviationDataService);
        entityDataService.registerService('BaselineCurrentPostureCount', swayBaselineCountDataService);
        entityDataService.registerService('TicketCount', swayTicketDataService);
    }
}
